import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  detailsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
  detailsToggle: {
    textTransform: 'none',
    minWidth: 0,
    paddingLeft: 0,
    color: 'inherit',
  },
  copyButton: {
    textTransform: 'none',
    color: 'inherit',
  },
  technicalDetails: {
    fontFamily: 'monospace',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(1, 0, 0),
  },
}));
